module.exports = __webpack_public_path__ + "img/bg.c86739fd.png";